import '@fontsource/source-sans-3/latin-400.css';
import '@fontsource/source-sans-3/latin-600.css';
import '@fontsource/source-sans-3/latin-700.css';
import '@fontsource/barlow-condensed/latin-600.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { SplashScreen } from './components/SplashScreen';
import { App } from './App';
import './styles/main.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    {import.meta.env.DEV && new URLSearchParams(window.location.search).get('view') === 'loading' ? <SplashScreen /> : <App />}
  </React.StrictMode>
);

if (import.meta.hot) import.meta.hot.dispose(() => root.unmount());
